import { useState, useEffect } from "react";
import { supabase } from "../components/SupabaseClient"; // import supabase

/**
 * Hook to fetch user count from Supabase RPC
 */
export const useUserCount = () => {
  const [userCount, setUserCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserCount = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error } = await supabase.rpc("get_user_count");
      if (error) throw error;

      let count;
      if (typeof data === "number") {
        count = data;
      } else if (typeof data === "string") {
        const parsed = parseInt(data, 10);
        if (Number.isNaN(parsed)) {
          throw new Error("Invalid bigint string returned from RPC");
        }
        count = parsed;
      } else if (typeof data === "bigint") {
        const parsed = Number(data);
        if (!Number.isSafeInteger(parsed)) {
          throw new Error("User count exceeds JS safe integer range");
        }
        count = parsed;
      } else {
        throw new Error("Unexpected RPC response type");
      }

      // console.log(`[useUserCount] Fetched user count: ${count}`);
      setUserCount(count);
    } catch (err) {
      console.error("Failed to get user count:", err);
      setError(err.message || "Unknown error");
      setUserCount(0);
    } finally {
      setLoading(false);
    }
  };

  const refreshUserCount = () => {
    fetchUserCount();
  };

  useEffect(() => {
    fetchUserCount();
  }, []);

  return {
    userCount,
    loading,
    error,
    refreshUserCount,
  };
};
